import React, { useRef } from 'react';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';
import type { Product } from 'reactApp/types/Billing';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import type { TariffByModalTab } from 'reactApp/ui/TariffsModal/TariffsModalContent.types';
import { TariffsModalContentMobile } from 'reactApp/ui/TariffsModalMobile/TariffsModalContentMobile/TariffsModalContentMobile';

import styles from './TariffsModalMobile.css';

interface TariffsModalMobileProps {
    tariffs: TariffByModalTab[];
    tariffIds: YearAndMonthProductIds;
    onClose: () => void;
    tabActive: ETabsName;
    setTabActive: (tab: ETabsName) => void;
    onBuyClick: (product: Product) => void;
    title: string;
    qaId?: string;
}

export const TariffsModalMobile = ({
    tariffs,
    onClose,
    tabActive,
    setTabActive,
    onBuyClick,
    tariffIds,
    title,
    qaId,
}: TariffsModalMobileProps) => {
    const scrollRef = useRef<HTMLDivElement>(null);
    return (
        <MobileDialog
            scrollRef={scrollRef}
            id={'buy-disable-ads'}
            mod="base"
            contextPadding="zero"
            open
            closeOnDimmerClick={false}
            closable
            onClose={onClose}
            className={styles.mobile_modal}
            topmost
        >
            <TariffsModalContentMobile
                tariffs={tariffs}
                yearTariffsCount={tariffIds?.year?.length || 0}
                monthTariffsCount={tariffIds?.month?.length || 0}
                title={title}
                activeTab={tabActive}
                setActiveTab={setTabActive}
                onBuyClick={onBuyClick}
                scrollRef={scrollRef}
                animate
                qaId={qaId}
            />
        </MobileDialog>
    );
};
